import React from 'react';

const StopIcon = ({ Stop }) => {
  return (
    <a
      style={{
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        marginTop: '-60px',
        marginLeft: '-53px',
        top: '40px',
        left: '0%',
        zIndex: '9999',
        textAlign: 'center',
        fontWeight: 'bold',
        color: 'rgb(0, 179, 181)',
        pointerEvents: 'none',
        fontSize: '20px',
      }}
    >
      <img 
        src={Stop}
        style={{
          maxWidth: '70px',
          maxHeight: '70px',
          objectFit: 'contain'
        }} 
        alt="Stop icon" 
      />
    </a>
  );
};

export default StopIcon;
